import React, { useEffect } from 'react';
import { Box, CircularProgress } from '@mui/material';
import { useNavigate, useParams } from 'react-router-dom';

/**
 * Legacy single-invoice pay route (`/portal/invoices/:invoiceId/pay`).
 * The actual pay surface is now `/portal/payments` (multi-invoice
 * select; supports a `?invoice=…` query param for the single-invoice
 * deep link). This component just forwards old bookmarks there.
 */
const PortalPayInvoice = () => {
  const navigate = useNavigate();
  const { invoiceId } = useParams();

  useEffect(() => {
    if (invoiceId) {
      navigate(`/portal/payments?invoice=${invoiceId}`, { replace: true });
    } else {
      navigate('/portal/payments', { replace: true });
    }
  }, [invoiceId, navigate]);

  return (
    <Box sx={{ display: 'flex', justifyContent: 'center', py: 6 }}>
      <CircularProgress />
    </Box>
  );
};

export default PortalPayInvoice;
